// src/components/LoadingScreen.jsx
import React, { useState, useEffect } from 'react';
import quotes from '../data/quotes.json';
import '../styles/LoadingScreen.css';

export default function LoadingScreen({ message }) {
  const [fadeOut, setFadeOut] = useState(false);
  const [quote] = useState(() => {
    // Pick random quote on mount (only once)
    return quotes[Math.floor(Math.random() * quotes.length)];
  });

  // Auto-trigger fade in after a brief moment (gives it time to mount)
  useEffect(() => {
    const timer = setTimeout(() => setFadeOut(true), 50);
    return () => clearTimeout(timer);
  }, []);

  // Use message prop if provided, otherwise use random quote
  const displayMessage = message || quote.text;
  const author = !message && quote.author ? `— ${quote.author}` : null;

  return (
    <div className={`loading-screen ${fadeOut ? 'fade-in' : ''}`}>
      <div className="loading-content">
        <div className="spinner"></div>
        <p className="loading-message">{displayMessage}</p>
        {author && <p className="loading-author">{author}</p>}
      </div>
    </div>
  );
}
